<template>
  <img
    v-if="custom"
    :src="custom.src"
    :alt="custom.name"
    class="inline-block size-[1.1em] object-contain align-[-0.15em]"
    draggable="false"
  />
  <span v-else class="leading-none">{{ value }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getCustomEmoji } from './comment-custom-emojis';

const props = defineProps<{
  value: string;
}>();

const custom = computed(() => getCustomEmoji(props.value));
</script>
